import React from 'react'
import PropTypes from 'prop-types'
import SpeciesDetailsSearchForm from './speciesDetailsSearchForm'


const SpeciesDetails = ({site}) => {
  return (
    <SpeciesDetailsSearchForm site={site}/>
  )
}

export default SpeciesDetails

SpeciesDetails.propTypes = {
  site: PropTypes.object.isRequired
}
